// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DucROL6vwolkKeXjXvRB{padding:var(--spacing-xSmall)}.lSmUJU0YNV2veHflZUo4,.f84gpx5_Wfl3LFQf2pgr{margin-bottom:var(--spacing-xSmall)}`, "",{"version":3,"sources":["webpack://./src/App/views/Privacy/Privacy.module.scss"],"names":[],"mappings":"AAAA,sBAAM,6BAA6B,CAAC,4CAAqB,mCAAmC","sourcesContent":[".card{padding:var(--spacing-xSmall)}.heading,.terms-link{margin-bottom:var(--spacing-xSmall)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `DucROL6vwolkKeXjXvRB`,
	"heading": `lSmUJU0YNV2veHflZUo4`,
	"terms-link": `f84gpx5_Wfl3LFQf2pgr`
};
export default ___CSS_LOADER_EXPORT___;
